module.exports = __webpack_public_path__ + "static/assets/96ef79ae828240ef0347016f5bc54911.svg";